import { render, staticRenderFns } from "./Resizable.vue?vue&type=template&id=ce0f940e&scoped=true"
import script from "./Resizable.vue?vue&type=script&lang=js"
export * from "./Resizable.vue?vue&type=script&lang=js"
import style0 from "./Resizable.vue?vue&type=style&index=0&id=ce0f940e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce0f940e",
  null
  
)

export default component.exports